import { zodResolver } from '@hookform/resolvers/zod';
import { ValidationErrorResponse } from '@wyz/types';
import { UseFormGetFieldState } from 'react-hook-form';
import { FEATURE_CONTEXT } from '~/common/schemas';
import { CommonErrorCodesEnumType } from '~/common/types';
import { BrandTemplateFormBase } from '~/connect/components';
import { BrandTemplateHelpers } from '~/connect/helpers';
import {
  BRAND_EAN_SPECIFICATIONS,
  brandTemplateFormSchema,
} from '~/connect/schemas';
import {
  IBrandTemplateForm,
  IBrandTemplatePayload,
  ICriteria,
} from '~/connect/types';

const DEFAULT_VALUES: IBrandTemplateForm = {
  name: '',
  criteria: [],
  brands: [],
  brandEanSpecification: BRAND_EAN_SPECIFICATIONS.NO_SPECIFICATION,
};

type Props =
  | {
      defaultValues?: Partial<IBrandTemplateForm>;
      mode?: 'CREATE' | 'UPDATE';
      isLoading: boolean;
      onSubmit: (
        data: IBrandTemplatePayload,
        formState: {
          criteria: ReturnType<UseFormGetFieldState<IBrandTemplatePayload>>;
        },
      ) => void;
      errors?: ValidationErrorResponse<CommonErrorCodesEnumType> | null;
    }
  | {
      mode?: 'READ_ONLY';
      defaultValues?: Partial<IBrandTemplateForm>;
      isLoading?: never;
      onSubmit?: never;
      errors?: never;
    };

export function BrandTemplateForm(props: Props) {
  const { mode = 'CREATE', defaultValues = DEFAULT_VALUES } = props;

  return (
    <BrandTemplateFormBase<IBrandTemplateForm>
      config={{
        variant: 'STANDARD',
        featureContext: FEATURE_CONTEXT.BRAND_TEMPLATE,
        cancelTo: '/platform/distribution/products-brands',
      }}
      resolver={zodResolver(brandTemplateFormSchema)}
      defaultValues={defaultValues}
      mode={mode}
      submission={
        props.mode === 'READ_ONLY'
          ? undefined
          : {
              isLoading: props.isLoading,
              errors: props.errors,
              onSubmit: (
                formData: IBrandTemplateForm,
                criteria: ICriteria[],
                formState,
              ) =>
                props.onSubmit?.(
                  BrandTemplateHelpers.fromFormToPayload(formData, criteria),
                  formState as {
                    criteria: ReturnType<
                      UseFormGetFieldState<IBrandTemplatePayload>
                    >;
                  },
                ),
            }
      }
    />
  );
}
